import { render } from "./AuthCode.vue?vue&type=template&id=6490b1e9&scoped=true"
import script from "./AuthCode.vue?vue&type=script&lang=js"
export * from "./AuthCode.vue?vue&type=script&lang=js"

import "./AuthCode.vue?vue&type=style&index=0&id=6490b1e9&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6490b1e9"]])

export default __exports__